import React from "react";
import ContactPage from "./ContactPage";

const SupportPage = () => {
  return (
    <ContactPage
      eyebrow="Soporte"
      title="Soporte"
      description="Si necesitas ayuda con la app, reportar un problema, hacer una consulta tecnica o pedir acompanamiento, aqui tienes un canal publico y directo para comunicarte con Apedir."
      highlightTitle="Soporte directo para usuarios"
      highlightDescription="Atendemos consultas sobre la app, problemas con pedidos, dudas de funcionamiento y solicitudes relacionadas con tu cuenta o tus datos."
      successTitle="Solicitud de soporte enviada"
      successDescription="Recibimos tu mensaje y lo revisaremos lo antes posible para darte respuesta."
    />
  );
};

export default SupportPage;
